// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_NsKo9","ws-info":"ws-info_DDmvY","title":"title_yCq8Z","coupons":"coupons_WMKFE"};